module.exports = __webpack_public_path__ + "assets/img/slogan-6466a2f1.png";